export default "__VITE_ASSET__0c488ca5__"